import { render, staticRenderFns } from "./VentaEditarModalPerseo.vue?vue&type=template&id=5f65052c&scoped=true"
import script from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
export * from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./VentaEditarModalPerseo.vue?vue&type=style&index=0&id=5f65052c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65052c",
  null
  
)

export default component.exports